import { getTemplateByIdUrl, getTemplatesUrl } from "../config/Config";
import { deleteRequest, getRequest, postRequest } from "./ServiceHelper";

export class TemplateService {
  static getTemplates = () => {
    return getRequest(getTemplatesUrl());
  };

  static upsertTemplate = (template) => {
    return postRequest(getTemplatesUrl(), template);
  };

  static deleteTemplate = (templateId) => {
    return deleteRequest(getTemplateByIdUrl(templateId));
  };
}
